
export const DISPLAY_STATUS = [
  { key: 0, text: 'All' },
  { key: 1, text: 'Active' },
  { key: 2, text: 'Disabled' },
]

export const SHIFT_TYPES = [
  { key: 1, text: 'Weekday' },
  { key: 2, text: 'Weekend' },
]
export const statusObj = {
  active: { key: 1, text: 'Active' },
  disabled: { key: 2, text: 'Disabled' },
}

export const DAYS = [
  { key: 1, name: "Monday" },
  { key: 2, name: "Tuesday" },
  { key: 3, name: "Wednesday" },
  { key: 4, name: "Thursday" },
  { key: 5, name: "Friday" },
  { key: 6, name: "Saturday" },
  { key: 7, name: "Sunday" }
];


export const PRIORITIES = [
  { key: 1, text: "Required" },
  { key: 2, text: "Elective" }
];
export const INFORM_STATUS = [
  { key: 1, text: 'Now' },
  { key: 2, text: 'Later' },
]

export const recordStatus = {
  active: { key: 1, text: 'Active' },
  disables: { key: 2, text: 'Disabled' },
}




export const admissionPrograms = {
  academic: { key: 1, text: 'Academic Program' },
  abc: { key: 2, text: 'ABC Course' },
  institutes: { key: 3, text: 'Institutes & Center' },
  shortCourse: { key: 4, text: 'Short Course' },
}

export const paymentStatus = {
  paid: { key: 1, text: "Paid" },
  unpaid: { key: 2, text: "Unpaid" },
  prepaid: { key: 3, text: "Prepaid" },
  void: { key: 4, text: "Void" },
};

export const invoiceTypeParams = {
  testing: { key: 1, text: "Testing" },
  tuition_fee: { key: 2, text: "Tuition Fee" },
  academic_program: { key: 2, text: "Academic Tuition Fee" },
  institute_and_center: { key: 2, text: "Institute Tuition Fee" },
  short_course: { key: 3, text: "Short Course" },
  abc: { key: 4, text: "Academic Bridging Course" },
  miscellaneous: { key: 6, text: "Miscellaneous" },
  scholarshipPenalty: { key: 7, text: "Scholarship Penalty" },
};
export const TestFeeStatus = {
  paid: { key: 1, name: 'Paid' },
  unpaid: { key: 2, name: 'Unpaid' },
  prepaid: { key: 3, name: 'Prepaid' },
  void: { key: 4, name: 'Void' },
  disables: { key: 5, name: 'Disables' },
}
export const Genders = [
  { key: '1', text: 'Male' },
  { key: '2', text: 'Female' },
  { key: '3', text: 'Monk' },
];

export const userRolesObj = {
  administrator: { key: 1, text: "Administrator" },
  testing: { key: 2, text: "Testing" },
  cashier: { key: 3, text: "Cashier" },
  DAA: { key: 4, text: "DAA" },
  enrollment: { key: 5, text: "Enrollment" },
  registrar: { key: 6, text: "Registrar" },
  faculty_manager: { key: 7, text: "Faculty Manager" },
  scholarship: { key: 8, text: "Scholarship" },
  human_resource: { key: 9, text: "Human Resource" },
  financial: { key: 10, text: "Financial" },
};

export const TestingStatus = {
  active: { key: 1, text: 'Active' },
  disables: { key: 2, text: 'Disabled' },
  expired: { key: 3, text: 'Expired' },
}

export const termsModulesObj = {
  semester_term: { key: 'semester_term', text: 'Semester Term', order: 1, icon: 'spa', type: 'Academic' },
  summer_term: { key: 'summer_term', text: 'Summer Term', order: 2, icon: 'wb_sunny', type: 'Academic' },
  accelerated_term: { key: 'accelerated_term', text: 'Accelerated Term', order: 3, icon: 'pages', type: 'Academic' },
  english_term: { key: 'english_term', text: 'English Term', order: 4, icon: 'pages', type: 'English' },
  japanese_term: { key: 'japanese_term', text: 'Japanese Term', order: 5, icon: 'pages', type: 'Japanese' },
}


export const InvoiceTypesObj = {
  testing: { key: 1, text: 'Testing' },
  schoolFee: { key: 2, text: 'School Fee' },
  shortCourse: { key: 3, text: 'Short Course' },
}

export const invoiceTypesObj = {
  testing: { key: 1, text: "Testing" },
  tuitionFee: { key: 2, text: "Tuition Fee" },
  shortCourse: { key: 3, text: "Short Course" },
  abcCourse: { key: 4, text: "Academic Bridging Course" },
  spel: { key: 5, text: "SPEL" },
  miscellaneous: { key: 6, text: "Miscellaneous" },
  scholarshipPenalty: { key: 7, text: "Scholarship Penalty" },
};

export const enrollPrograms = {
  academic: { key: 1, text: 'Academic Program' },
  abc: { key: 2, text: 'Academic Bridging Course' },
  institutes: { key: 3, text: 'Institutes & Center' },
  shortCourse: { key: 4, text: 'Short Course' },
}

export const TERM_TYPES_OBJECT = {
  "semester-term": { key: "semester-term", text: "Semester Term" },
  "accelerated-term": { key: "accelerated-term", text: "Accelerated Term" },
  "architecture-term": { key: "architecture-term", text: "Architecture Term" },
}
export const PAYMENT_METHODS = [
  { key: "credit", text: "Credit" },
  { key: "blog", text: "Blog" },
  { key: "course", text: "Course" },
]

export const DISPLAY_STATUS_OBJECT = {
  'ACTIVE': { key: 1, text: 'Active' },
  'DISABLED': { key: 2, text: 'Disabled' },
}

export const STATUS_OBJECT = {
  'draft': { key: 1, text: 'Draft', router: 'draft' },
  'submitted': { key: 2, text: 'Submitted', router: 'submitted' },
  'deleted': { key: 3, text: 'Deleted', router: 'deleted' },
}

export const SKILL_OBJECT = {
  'READING': { key: 'reading', text: 'Reading' },
  'LISTENING': { key: 'listening', text: 'Listening' },
  'GRAMMAR': { key: 'grammar', text: 'Grammar' },
  'VOCABULARY': { key: 'vocabulary', text: 'Vocabulary' },
  'SPEAKING': { key: 'speaking', text: 'Speaking' },
}

export const GENDERS = [
  { key: 1, text: 'Male' },
  { key: 2, text: 'Female' },
  { key: 3, text: 'Monk' },
];

export const STUDENT_FILER_OPTIONS = [
  { key: "fullName", text: "Full Name" },
  { key: "phoneNumber", text: "Phone" },
  { key: "email", text: "Email" },
];

export const READING_MEMBER_OBJECT = {
  'free': { key: 0, text: 'Free', router: 'free' },
  'students': { key: 1, text: 'Students', router: 'students' },
  'teachers': { key: 2, text: 'Teachers', router: 'teachers' },
  'parents': { key: 3, text: 'Parents', router: 'parents' },
  'premium': { key: 4, text: 'Premium', router: 'premium' },
  'training': { key: 5, text: 'Language Training', router: 'training' },
}

export const APP_MEMBER_OBJECT = {
  'reading': { key: 'reading', text: 'Reading', router: 'reading' },
}

export const PACKAGE_ARR = [
  { key: 0, text: 'Free', totalMonth: 0 },
  { key: 3, text: '3 Months', totalMonth: 3 },
  { key: 6, text: '6 Months', totalMonth: 6 },
  { key: 12, text: '1 Year', totalMonth: 12 },
]

export const GENDER_DATA = [
  { key: 1, text: 'ប្រុស', en_name: 'Male' },
  { key: 0, text: 'ស្រី', en_name: 'Female' },
]
